<template>
  <button
    :class="small ? 'py-0.5 px-4' : ''"
    class="flex flex-none !flex-nowrap font-medium items-center justify-center gap-[8px] leading-7 w-fit h-fit py-0.5 px-4 text-secondary-900 text-base bg-secondary-500 rounded hover:shadow-button hover:bg-secondary-200 focus:bg-secondary-100 focus:shadow-none active:bg-secondary-100 active:shadow-none disabled:bg-grays-400 disabled:shadow-none disabled:text-grays-600"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "button-cta",
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>